import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "@/components/Reveal";

export const useIntro = () => {
  const [done, setDone] = useState(() => sessionStorage.getItem("babylon-intro") === "1");
  useEffect(() => {
    if (done) return;
    const t = setTimeout(() => {
      sessionStorage.setItem("babylon-intro", "1");
      setDone(true);
    }, 2600);
    return () => clearTimeout(t);
  }, [done]);
  return done;
};

export default function Preloader({ done }) {
  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          key="preloader"
          exit={{ opacity: 0, transition: { duration: 1, ease: EASE } }}
          className="fixed inset-0 z-[200] bg-obsidian flex flex-col items-center justify-center"
          data-testid="preloader"
        >
          <motion.img
            src="/images/logo.png"
            alt="BABYLON"
            initial={{ opacity: 0, scale: 0.96, filter: "blur(6px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.6, ease: EASE, delay: 0.2 }}
            className="h-10 sm:h-14 w-auto"
          />
          <div className="mt-10 h-px w-40 bg-white/[0.08] overflow-hidden">
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              transition={{ duration: 2.1, ease: [0.65, 0, 0.35, 1], delay: 0.3 }}
              className="h-full w-full bg-gold"
            />
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 1 }}
            className="mt-6 font-mono text-[9px] tracking-[0.5em] uppercase text-gold/60"
          >
            Conciergerie horlogère privée
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
